<template>
  <b-card border-variant="secondary">
    <Notification v-bind.sync="notification" />

    <b-card-title title-tag="h4" class="mb-1">
      Change your password
    </b-card-title>
    <b-card-body>
      <b-row class="mb-2">
          <InputField
            label="Current Password"
            v-model="currentPassword"
            :options="{ ...defaultOptions, id: 'current_password' }"
          />
      </b-row>
      <b-row class="mb-2">
          <InputField
            label="New Password"
            v-model="newPassword"
            :disabled="disabled.new"
            :valid="sameConfirm"
            :options="{ ...defaultOptions, id: 'new_password'}"
          />
          <InputField
            label="Confirm Password"
            v-model="confirmPassword"
            :disabled="disabled.confirm"
            :valid="sameConfirm"
            :options="{ ...defaultOptions, id: 'confirm_password'}"
            @key:enter="changePassword"
          />
      </b-row>
      <b-row class="mb-0">
        <b-col class="text-center" cols="12" md="6" offset-md="3" lg="4" offset-lg="4">
          <b-button
            class="rounded-0"
            :disabled="disabled.submit"
            @click="changePassword"
          >
            Submit
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import Notification from '@/components/Notification';
import InputField from '@/components/InputField';
import ResourceService from '@/services/ResourceService';

const resource = new ResourceService();

export default {
  name: 'UserPassword',
  components: {
    InputField,
    Notification,
  },
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      disabled: {
        new: true,
        confirm: true,
        submit: true,
      },
      sameConfirm: null,
    };
  },
  watch: {
    currentPassword(val) {
      const hasVal = Boolean(val.trim());
      this.disabled.new = !hasVal;
      this.disabled.confirm = !hasVal;
    },
    confirmPassword(val) {
      if (this.confirmPassword.length > 0) {
        this.sameConfirm = (val === this.newPassword);
      } else {
        this.sameConfirm = null;
      }
    },
    newPassword(val) {
      if (this.confirmPassword.length > 0) {
        this.sameConfirm = (val === this.confirmPassword);
      } else {
        this.sameConfirm = null;
      }
    },
    sameConfirm(val) {
      this.disabled.submit = !val;
    },
  },
  computed: {
    defaultOptions() {
      return {
        tagClass: 'col-12 col-sm-6 mb-2',
        labelClass: 'font-weight-bold mb-0',
        inputClass: 'form-control no-outline border-dark border-bottom rounded-0',
        type: 'password',
      };
    },
    ...mapGetters(['userData', 'initPassword']),
    ...mapState(['notification']),
  },
  methods: {
    changePassword() {
      const { id } = this.userData;
      const params = { password: this.currentPassword, newPassword: this.newPassword };
      resource.post(`/user/${id}/password`, params)
        .then(({ success, message }) => {
          const icon = success ? 'check' : 'exclamation';
          this.setNotification({
            message,
            show: 3,
            variant: success ? 'success' : 'danger',
            icon: { name: icon },
          });

          if (!this.initPassword) {
            this.setPasswordDone();
            this.resetAlert();
            this.$router.push({ name: 'home' });
          }
        })
        .catch(error => this.setNotification(
          { show: 3, variant: 'danger', message: error.message || 'An error occurred' },
        ))
        .then(this.resetForm);
    },
    resetForm() {
      this.currentPassword = '';
      this.newPassword = '';
      this.confirmPassword = '';
    },
    ...mapActions([
      'setNotification',
      'setPasswordDone',
      'resetAlert',
    ]),
  },
};
</script>
